import levels from './levels';

/**
 * Defines a custom metric
 * @function defineMetric
 * @example
 * import {defineMetric} from '@servicenow/ui-metrics';
 *
 * export const initCustomMetrics = () => {
 *		if (shouldPersistMetrics) {
 *			setInteractionId();
 *			window.addEventListener('unload', () => {
 *				persistMetrics();
 *			});
 *
 *			defineMetric('NAVIGATE', 4);
 *			persistAtInterval(intervalDuration);
 *		}
 * };
 *
 * @param {String} name
 * @param {Number} level
 */
export default function defineMetric(name, level = 0) {
	if (levels[name]) throw new Error(`@servicenow/ui-metrics ${name} is already a defined metric.`);
	if (!Number.isInteger(level) || level > 5 || level < 0)
		throw new Error(`@servicenow/ui-metrics ${level} is not valid metric level.`);

	levels[name] = level;
}
